import React, { ReactNode } from 'react';

import {
  ActionButtons,
  Button,
  LoadingSpinner,
  UserAlert,
} from '@hcs/design-system';

import { useUserSelfServiceConfirmed } from '../../hooks/useUserSelfServiceConfirmed';

import styles from './SelfServiceConfirmAccount.module.css';

interface SelfServiceConfirmAccountProps {
  className?: string;
  confirmationText: ReactNode;
  onGetStarted?: VoidFunction;
  onCancel?: VoidFunction;
}
const dataHcName = 'self-service-confirm-account';
export const SelfServiceConfirmAccount = ({
  className,
  confirmationText,
  onGetStarted,
}: SelfServiceConfirmAccountProps) => {
  const { data: isUserConfirmed, isInitialLoading: isUserConfirmedIsLoading } =
    useUserSelfServiceConfirmed();

  const Wrapper = ({ children }: { children: React.ReactNode }) => {
    return (
      <div data-hc-name={dataHcName} className={className}>
        {children}
      </div>
    );
  };

  if (isUserConfirmedIsLoading) {
    return (
      <Wrapper>
        <LoadingSpinner dataHcName={`${dataHcName}-skeleton`} />
      </Wrapper>
    );
  }

  return (
    <div className={styles.Success}>
      <UserAlert
        type="success"
        dataHcName={`${dataHcName}-success`}
        text="Account Setup Complete"
        className={styles.UserAlert}
      />
      {!isUserConfirmed && <p>{confirmationText}</p>}
      {isUserConfirmed && onGetStarted && (
        <ActionButtons dataHcName={`${dataHcName}-actions`}>
          <Button
            label="Get Started"
            onClick={onGetStarted}
            dataHcName={`${dataHcName}-get-started-button`}
          />
        </ActionButtons>
      )}
    </div>
  );
};
